/**
 * API CEI Apps
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * * `CPF` - CPF * `RG` - RG * `CNH` - CNH * `Passaporte` - Passaporte * `RNE` - RNE
 */
export enum DocumentoTipoEnum {

    CPF = 'CPF',

    RG = 'RG',

    CNH = 'CNH',

    PASSAPORTE = 'Passaporte',

    RNE = 'RNE'
}

